
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registracija",
      function () {
        return require("private-next-pages/registracija.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registracija"])
      });
    }
  